import { ViteReactSSG } from "vite-react-ssg";
import { routes } from "./routes";
import { createRouter } from "./lib/router";
import "./styles/globals.css";

export const createRoot = ViteReactSSG({ routes, customCreateRouter: createRouter });
